export const IndicatorsDataEn = [
  //OTM Trading Como Sistema
  {
    linkTit: "How we use OTM Trading",
    url: "how-we-use-otm-trading",

    imgb: "./features/operativa-crudo-en.gif",
    titb_1: "How we use OTM Trading",
    txtb0:
      "OTM Trading is a tool that helps you have clear and simple information about supply and demand. To make the most of it, it's best to synchronize all indicators and show the same information at the time of making a buying or selling decision.",
    txtb1:
      "In the previous example, we made a successful long trade on Crude Oil  (CL) and earned $360 dollars. ",
    txtb2:
      "Do you want to make a long trade with OTM Trading? Here are some important tips for you to succeed:    ",

    txmb3:
      "1. Look for a large 'green box' on the MicroDelta indicator and an uptrend movement on Japanese candles. ",

    txmb4:
      "2. Asegúrate de que los retrocesos tengan 'cajas rojas' mucho más pequeñas que la caja verde de compra.",

    txmb5:
      "3. Verifica que la gráfica del Delta Acumulado esté en verde y creciente, lo que indica presión compradora.",

    txmb6:
      "4. Busca una zona de bajo volumen en el perfil de volumen para encontrar la entrada perfecta de compra.",

    txtb7:
      "¿Quieres hacer una operación de venta (corto) con OTM Trading? La misma lógica se aplica aquí, solo que en lugar de buscar compras grandes, debes buscar ventas grandes. ¡Así de fácil!",

    txtb8:
      "Si quieres aprender aún más sobre OTM Trading y cómo puedes aprovecharlo al máximo, te invito a que te unas a la MasterClass. ¡Allí podrás ampliar todo lo que has aprendido y tener aún más herramientas para tener éxito en tus operaciones!",

    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },

  //Explicación Indicadores
{
  linkTit: "OTM Algorithms",
  url: "otm-algorithms",

  imgb: "./features/otm-algorithms2.png",
  titb_1: "OTM Algorithms",

  txtb0:
    "This indicator integrates three powerful algorithms designed to analyze order flow and give you a clear view of the dominant market activity. Each one fulfills a specific role so you can detect opportunities with greater precision:",

  txmb1:
    "1. Delta Dominance: Identifies consecutive bars where delta took full control. This allows you to clearly recognize when one of the forces —buying or selling— completely dominates the price action.",

  txmb2:
    "2. Candle Detector: Highlights bars that meet a specific delta and volume criterion, filtering only those candles that show a statistically relevant pattern. This way, you can focus your attention on key moments without wasting time on insignificant signals.",

  txmb3:
    "3. Delta Aggressive: Displays sequences of consecutive bars with high delta, showing phases of strong aggressiveness from buyers or sellers. This is useful for detecting intense impulses that can anticipate breakouts or sharp trend changes.",

  txtb1:
    "With OTM Algorithms you get a versatile tool that combines three complementary approaches, giving you direct and objective information for your analysis.",

  lnkb1: ["/buy", "Get Started"],
},



  {
    linkTit: "OTM Delta Swing",
    url: "otm-delta-swing",
    imgb: "./features/otm-delta-swing-en.jpg",
    titb_1: "OTM Delta Swing",
    txtb0:
      "This indicator provides you with valuable information about price wave movements:",
    txmb1:
      "1. Volume and delta information: With this information, you can evaluate whether or not to take a position, as you can directly see the strength of each wave.",
    txmb2:
      "2. Informative signals: OTM Delta Swing's algorithms detect anomalies, which means they allow you to detect events that are outside the norm and thus give you an advantage in the market. The algorithm detects 3 types of anomalies and shows us an informative signal at the end of the wave.",
    txtb1:
      "I recommend you watch the following video about the signals and types of anomalies detected by OTM Delta Swing so you can understand it better and get the most out of it:",
    lnkb1: ["https://www.youtube.com/watch?v=AWTLJAKa2VI", "OTM Delta Swing"],
  },
  {
    linkTit: "OTM Delta Micro",
    url: "otm-delta-micro",
    imgb: "./features/otm-delta-micro-en.jpg",
    titb_1: "OTM Delta Micro",
    txtb0:
      "When there is a great interest from buyers or sellers in moving the price in one direction, it can be easily identified with this indicator. With OTM Micro Delta you will be able to:",
    txmb1:
      "1. Have a reference threshold: this is key to filter out important movements from those that are not.",
    txmb2:
      "2. Institutional Delta: when we see a large 'green box' it means that there is a large number of buyers who want the price to go up, this is called 'Momentum'.",
    txtb1:
      "To use this indicator in the best way possible, it is important to understand some key concepts, but don't worry, they are very easy to understand! Additionally, we have a video where we explain everything:",
    lnkb1: ["https://www.youtube.com/watch?v=0LRXTXaFOko", "OTM Delta Micro"],
  },
  {
    linkTit: "OTM Delta Cumulative",
    url: "otm-delta-cumulative",
    imgb: "./features/otm-delta-cumulative-en.jpg",
    titb_1: "OTM Delta Cumulative",
    txtb0:
      "This indicator is a histogram, a histogram graphically displays the characteristics of a dataset, in this case summarizing the behavior of delta. Delta is a measure of the buying or selling strength in the market. Some practical applications are:",
    txmb1:
      "1. Identifying trend transitions: we can see if a trend is coming to an end.",
    txmb2:
      "2. Identifying defined trends: if we want to buy, it's important to observe a green graph that is increasing, indicating a constant pressure from buyers.",
    txtb1:
      "Depending on the type of strategy you have, there are some important aspects to consider with this indicator. Therefore, I invite you to learn more about OTM Cumulative Delta in the following video:",
    lnkb1: ["https://www.youtube.com/watch?v=HJtZ3gJK1FE", "OTM Cumulative Delta"],
  },
  {
    linkTit: "OTM Delta Bar",
    url: "otm-delta-bar",
    imgb: "./features/otm-delta-bar-en.jpg",
    titb_1: "OTM Delta Bar",
    txtb0:
      "If you want to know the delta value of a bar in detail, OTM Delta Bar is a very useful and versatile tool that presents you with multiple options:",
    txmb1:
      "1. Session cumulative delta: displays the behavior of delta throughout the session, like a Japanese candlestick chart, but for delta behavior. It's useful for confirming exhaustion and detecting possible market changes.",
    txmb2:
      "2. Delta per bar 1: displays positive and negative values in the same direction.",
    txmb3:
      "3. Delta per bar 2: positive delta will be up and negative delta down.",
    txmb4:
      "4. BID/ASK: displays the values of BID (aggressive sales) and ASK (aggressive purchases) of each candlestick.",
    txmb5:
      "5. Volume + Delta: the bars displayed are of volume, and the color represents the result of the candle's delta. The intensity of the color depends on how big that delta value is relative to its volume.",
    txmb6:
      "6. Footer volume + delta: here you can see the numerical values of delta, volume, BID, ASK, among others.",
    // txtb1:
    //   "The paid version includes all 6 different configurations, there is a free version that you can download that includes configuration #1 and #3. You can learn more and download the indicator on the following button.",
    lnkb1: ["https://youtu.be/Z7nISubWyaw", "OTM Delta bar Free"],
  },
  {
    linkTit: "OTM Volumne Profile",
    url: "otm-volume-profile",

    imgb: "./features/otm-profile-en.jpg",
    titb_1: "OTM Volume Profile",

    txtb0:
      "Volume profile is a very useful tool to understand the behavior of market participants and find important zones where the price may react. Here are some practical uses:",

    txmb1:
      "1. VPOC (Volume point of control): It is the most traded level during the session, works like a magnet for the price and can indicate an exit zone instead of an entry. ",

    txmb2:
      "2. Low volume nodes: These are zones where the trading volume is low and can serve as support or resistance levels, which means that the price may bounce off these zones and offer good entry or exit points. ",

    txmb3:
      "3. Value area: It refers to the price range where 70% of the total session volume is traded. When the price reaches the high (VAH) or low (VAL) end of the value area, there may be a trend reversal, so it is important to pay attention to these zones. ",

    txtb1: "Learn more about OTM Volume Profile in the following video:",

    lnkb1: ["https://youtu.be/yWkcqBqUkJ4", "OTM Volume Profile"],
  },
  {
    linkTit: "OTM VWAP",
    url: "otm-wap",
    imgb: "./features/otm-vwap-en.jpg",
    titb_1: "OTM VWAP",
    txtb0:
      "VWAP is a very useful indicator in trading and its calculation is quite simple. VWAP stands for 'Volume Weighted Average Price' and it is like a moving average that is constructed with the trading volume of the market. This indicator has several lines that can serve as a reference for our trades:",
    txmb1:
      "1. VWAP: This is the 'Central' or main VWAP. If the price is above it, we can take it as support and buy when the price reaches near this line. If the price is below it, we will take it as a resistance.",
    txmb2:
      "2. VWAP deviation 1: The VWAP has lines called deviations that replicate the behavior of the central line at a certain distance (standard deviation), we have them above and below, this is the lower deviation #1.",
    txmb3:
      "3. VWAP deviation 2: As the price advances with a clear direction, it is increasingly expanding and possibly on retracements it may not reach the central VWAP. Here, the deviations can serve as a reference for the location of our trades.",
    txmb4:
      "4. VWAP deviation 3: Once we observe that the price has reached deviation #3 of the VWAP, it means that the price is very extended and it is possible that very deep retracements or changes of direction will come later. We can use this deviation as an exit point for our trades.",
    lnkb1: ["https://youtu.be/_caBCZk4ZgI", "OTM VWAP"],
  },
  {
    linkTit: "OTM Graphic Bar Timer",
    url: "otm-bar-timer",
    imgb: "./features/otm-bar-timer-en.jpg",
    titb_1: "OTM Graphic Bar Timer",
    txtb0:
      "You may know the NinjaTrader Bar Timer indicator, which tells you how much time is left until a candle closes. This indicator works on the same principle, but displays the progress of the candle's construction using a color-coded bar.",
    txmb1:
      "1. 25% remaining: you can choose any color, but green indicates that the candle is about to close, making it easier for you to make a decision.",
    txmb2:
      "2. 50% remaining: less than half the time for the candle to close has passed, so it may be premature to make a decision. That's why the color is yellow.",
    txmb3:
      "3. 75% remaining: the candle is still forming, and the information within it can change dramatically before it closes, so it's better to wait a bit.",
    txtb1:
      "This indicator helps you easily identify which stage the candle's construction is at, allowing you to wait for the proper confirmation before pulling the trigger.",
    lnkb1: ["https://youtu.be/xN0rmD1b1sM", "OTM Graphic Bar Timer"],
  },
  {
    linkTit: "Momentum",
    url: "momentum-strategy",
    imgb: "./features/momentum-en.png",
    titb_1: "(Momentum) in favor of the trend",
    txtb0:
      "Whenever possible, you should go in favor of the trend. Here are the requirements for a trend-following entry:",
    txmb1:
      "1. VWAP in favor of the movement: if the price is above the VWAP, we should take long positions, waiting for the price to return to the VWAP. Conversely, if the price is below the VWAP, we should take short positions. We can use the main VWAP or deviations as support or resistance.",
    txmb2:
      "2. Momentum in the MicroDelta: if we are in a bullish market and we see a large green box in the MicroDelta, this indicates a large amount of aggressive buying. This is a good time to evaluate a long position in the market. On the other hand, if we see a large red box in the MicroDelta in a bearish market, this indicates aggressive selling, meaning there is bearish momentum.",
    txmb3:
      "3. Weak response on the retracement: if we had a large buying momentum (large green box), what we want is for the retracement to have much less volume than the initial impulse movement.",
    txmb4:
      "4. Accumulated delta in favor: in a bullish movement, this confirms that we have a constant pressure of buying and makes our long position more likely.",
    txmb5:
      "5. Low Volume Area: after the price has advanced, you should wait for the retracement in the low volume area that the volume profile leaves, this gives you a clear entry zone where you can support your position.",
    txtb1:
      "I hope this has helped you better understand the entry requirements in favor of the trend. If you want to learn more, don't hesitate to click on the button below to keep learning!",
    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },
  {
    linkTit: "Reversals",
    url: "reversals-strategy",
    imgb: "./features/reversal-en.png",
    titb_1: "(Reversals) against the trend",
    txtb0:
      "Reversal or against-trend entries are a bit more difficult, but if you have the following requirements, you are more likely to succeed in your trades:",
    txmb1:
      "1. Objective level of support or resistance: prices usually don't change direction without finding a key level. In this example, the price holds above the IBL (Initial Balance Low), which is the minimum level that the American session leaves in its first hour.",
    txmb2:
      "2. Decreasing supply: we need to see that there is less and less sales volume in the MicroDelta, which indicates that the supply is decreasing.",
    txmb3:
      "3. Buying divergence: another important signal that the price may be about to change direction is if there are divergence boxes. This means that the price is falling, but the delta is not negative, it is positive, which represents significant buying activity.",
    txmb4:
      "4. Divergence in the accumulated session delta: we also need to confirm that there is a divergence between the price and the accumulated delta per session. This means that the delta is growing and the price is still sideways.",
    txmb5:
      "5. Positive accumulated delta (divergence): finally, the delta histogram must also be positive and opposite to the price movement, which confirms that there is an anomaly.",
    txtb1:
      "If these requirements are met, a trend reversal may be occurring and we may consider entering a long position. Learn more in the video we have prepared for you about this strategy.",
    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },

  //¿Listo? Revisa esto para comenzar
  {
    linkTit: "Frequently Asked Questions",
    url: "frequently-asked-questions",

    titb_1: "Frequently Asked Questions",

    subb1:
      "1. Do I need a permanent license of NinjaTrader 8 to use OTM Trading?",

    txmb1:
      "No, you don't need a lifetime license of NinjaTrader 8 to use OTM Trading. You can use the demo version, and it will perform well.",

    subb2:
      "2. What is the process to install and set up the software on my computer?",

    txmb2:
      "Once you buy OTM Trading, you'll see a simple form where we'll ask you to enter your personal information and the Machine ID code. With this information, we'll license your software, and we'll send you OTM Trading via email with all the necessary instructions and educational materials so you can use it effectively.",

    subb3: "3. What type of license do I get after purchasing OTM Trading?",

    txmb3:
      "You get a lifetime license. You don't have to pay any more money after buying the OTM Trading pack. It's a one-time payment. You also have future updates included for free.",

    subb4:
      "4. Is there a technical support team to solve any problems that may arise?",

    txmb4:
      "Of course! If you have any problems after acquiring OTM Trading, don't worry. We're here to help you! You can contact us by email or WhatsApp to solve any doubts or problems you may have. Also, you can schedule a remote session with us to solve any problems in real-time!",

    subb5:
      "5. What are the opinions and reviews of other users who have used OTM Trading?",

    // txlb_5: [
    //   "If you want to know what other traders think about OTM Trading, you just have to <link> click here </link> and you'll see how OTM has helped them improve their operations.",
    //   "https://link.co",
    // ],

    subb6:
      "6. How accurate are the analyses and signals provided by OTM Trading?",

    txmb6:
      "OTM Trading has proven to be a great tool for your trading. You can see its performance in the year 2022 in the 'Results' tab. Don't miss the opportunity to improve your operations with this tool!",

    subb7: "7. Do the indicators work in any timeframe and chart type?",

    txmb7:
      "Yes, you can configure OTM Trading in any timeframe you want and in any chart type you prefer. It's very versatile.",

    subb8: "8. In what type of markets can I use OTM Trading?",

    txmb8:
      "With OTM Trading, you can trade a wide variety of financial instruments in the futures market, such as the SP500 (ES), Nasdaq (NQ), oil (CL), and currency futures. Please note that for some instruments, such as oil and currencies, it's necessary to have access to real-time data.",

    subb9: "9. Do I have to configure OTM Trading from scratch to use it?",

    txmb9:
      "Don't worry, if configuring OTM Trading options seems complicated, we've got you covered! In the installation manual that you'll receive with OTM Trading, we include a free template that will allow you to create charts with predefined settings in just one click. It's super easy!",

    subb10:
      "10. Is there a community of OTM Trading users that I can interact with and share experiences?",
    txlb10: [
      "After purchasing OTM Trading, you have access to a support community and additional resources! You can join our private Telegram channel and Discord server to receive support and share your experiences with other users. <link> Click here </link> to join now!",
      "https://t.me/comunidad3c",
    ],
    subb11: "11. Does OTM Trading require 'tick replay' for its operation?",
    txmb11:
      "OTM Trading does not use tick replay in version 2.5, so you can use it without worrying about that! You won't have software that slows down your computer.",
    subb12: "12. Does OTM Trading inform me where to enter and exit my trades?",
    txmb12:
      "OTM Trading provides you with information from different indicators, but ultimately, the decision of how to trade is yours. It's not an automatic trading system that makes trades for you, but it gives you information so that you can make your own informed decisions.",
    subb13: "13. What is the best way to use OTM Trading?",
    txlb13: [
      "If you want to get the best results with OTM Trading, it's important to have confirmation on all the indicators in the direction you want to trade. If you need help with OTM Trading, don't worry! We have educational videos on the different available strategies. Just <link> click here </link> to access them and learn how to use OTM Trading in the best way.",
      "https://www.otmtrading.com/features/momentum-strategy",
    ],
    subb14:
      "14. What are the minimum requirements for my computer to use OTM Trading optimally?",
    txmb14:
      "Don't worry, the requirements to use OTM Trading are simple. They are the same as those required to use the NinjaTrader 8 platform, and are easily achievable on most systems:",
    tmnb1:
      "- Windows 8.1, Windows 10, Windows 11, Windows Server 2012 or later",
    tmnb2: "- 1 Gigahertz (GHz) or faster. 32-bit or 64-bit processor",
    tmnb3: "- 2GB RAM",
    tmnb4:
      "- Microsoft .NET 4.8 (pre-installed on most PCs and can also be downloaded at Microsoft .NET Framework)",
    tmnb5: "- Minimum screen resolution 1024 x 768",
    tmnb6: "- DirectX 10 graphics card compatibility is highly recommended",
    subb15: "15. Can I perform Market Replay with OTM Trading?",
    txmb15:
      "Yes! You can replay the live market experience with OTM Trading using the NinjaTrader 8 Replay Market function.",
    subb16:
      "16. Are there any additional costs or subscriptions required after the initial purchase?",
    txmb16:
      "Don't worry, after purchasing OTM Trading, there are no additional costs or subscriptions required for its use. You'll be ready to start improving your trades!",
    subb17: "17. How do I update OTM Trading and how much does it cost?",
    txmb17:
      "After purchasing OTM Trading, don't worry about additional costs or subscriptions. If there's a new version available, we'll let you know by email with instructions on how to update, and it won't cost you anything extra!",

    subb18:
      "18. Is the software intuitive and easy to use for traders of all experience levels?",
    txmb18:
      "Don't worry, we'll teach you how to install and set up OTM Trading with our easy-to-follow instruction manual. Even if you have basic knowledge of the NinjaTrader 8 platform, you can do it without any problem. In addition, we provide education so that you can get the most out of the indicators.",
    subb19: "19. Does OTM Trading allow me to automate my trading operations?",
    txmb19:
      "Sorry, for now it is not possible to create automated strategies with OTM Trading indicators, but our team of experts is constantly working to improve and expand the software's functions.",
    subb20:
      "20. Is there a demo version available to try out OTM Trading before purchasing it?",
    txmb20:
      "We're sorry, we currently do not have a trial version available, but you can schedule an appointment with one of our advisors by clicking here. It will be a pleasure to help you solve your doubts and show you everything that OTM Trading can offer!",
  },
  {
    linkTit: "I pay and then what?",
    url: "payments",
    titb_1: "Do I pay first and then what?",
    iinb: "./features/compra.jpg",
    txtb1:
      "Once you have purchased OTM Trading, you will receive a form where you will need to enter your personal information, such as your name, email, and Machine ID code. Don't worry if you don't know how to get the Machine ID code, as the form has a tutorial image to guide you. Once you have completed the form, submit it and that's it! We will process your license as soon as possible and send you an email with all the necessary instructions to download, install, and start using OTM Trading. Additionally, we will also provide you with a list of recommended educational videos so you can make the most of the tool.",
    txtb2:
      "If you need help with financing, you can click here and contact one of our advisors through WhatsApp to get information on the different payment methods and financing options available to purchase OTM Trading.",
    txlb_3: [
      "You can also send us your questions or doubts by clicking <link>here</link>. We will be happy to assist you with anything you need. ",
      "http://bit.ly/42VBmoV",
    ],
  },
  {
    url: "none",
  }
];

export const IndicatorsDataEs = [
  //OTM Trading Como Sistema
  {
    linkTit: "Así usamos OTM Trading",
    url: "asi-usamos-otm-trading",

    imgb: "./features/operativa-crudo-es.gif",
    titb_1: "Así usamos OTM Trading",
    txtb0:
      "OTM Trading es una herramienta que te ayuda a tener información sobre la oferta y la demanda de manera clara y sencilla. Para aprovecharlo al máximo, lo mejor es que todos los indicadores se sincronicen y muestren la misma información en el momento de tomar una decisión de compra o venta.",
    txtb1:
      "En el ejemplo anterior, hicimos una operación de compra en el Crudo (CL) y ¡nos fue genial! ganamos $360 dólares.",
    txtb2:
      "¿Quieres hacer una operación de compra con OTM Trading? Aquí te damos algunos consejos importantes para que tengas éxito:",

    txmb3:
      "1. Busca una 'caja verde' grande en el indicador MicroDelta y un movimiento alcista en las velas japonesas.",

    txmb4:
      "2. Asegúrate de que los retrocesos tengan 'cajas rojas' mucho más pequeñas que la caja verde de compra.",

    txmb5:
      "3. Verifica que la gráfica del Delta Acumulado esté en verde y creciente, lo que indica presión compradora.",

    txmb6:
      "4. Busca una zona de bajo volumen en el perfil de volumen para encontrar la entrada perfecta de compra.",

    txtb7:
      "¿Quieres hacer una operación de venta (corto) con OTM Trading? La misma lógica se aplica aquí, solo que en lugar de buscar compras grandes, debes buscar ventas grandes. ¡Así de fácil!",

    txtb8:
      "Si quieres aprender aún más sobre OTM Trading y cómo puedes aprovecharlo al máximo, te invito a que te unas a la MasterClass. ¡Allí podrás ampliar todo lo que has aprendido y tener aún más herramientas para tener éxito en tus operaciones!",

    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },

  //Explicación Indicadores

  {
    linkTit: "OTM Algorithms",
    url: "otm-algorithms",

    imgb: "./features/otm-algorithms2.png",
    titb_1: "OTM Algorithms",

    txtb0:
      "Este indicador integra tres potentes algoritmos diseñados para analizar el flujo de órdenes y ofrecerte una visión clara de la actividad dominante en el mercado. Cada uno cumple un rol específico para que puedas detectar oportunidades con mayor precisión:",

    txmb1:
      "1. Delta Dominance: Identifica barras consecutivas en las que el delta tomó el control absoluto. Esto te permite reconocer con claridad cuándo una de las fuerzas —compradora o vendedora— domina por completo la acción del precio.",

    txmb2:
      "2. Candle Detector: Resalta barras que cumplen un criterio específico de delta y volumen, filtrando únicamente aquellas velas que muestran un patrón estadísticamente relevante. Así puedes centrar tu atención en los momentos clave sin perder tiempo en señales poco significativas.",

    txmb2:
      "3. Delta Aggressive: Muestra secuencias de barras consecutivas con delta elevado, evidenciando fases de fuerte agresividad por parte de compradores o vendedores. Esto es útil para detectar impulsos intensos que pueden anticipar rupturas o cambios bruscos en la tendencia.",



    txtb1:
      "Con OTM Algorithms obtienes una herramienta versátil que combina tres enfoques complementarios, dándote información directa y objetiva para tu análisis.",

    lnkb1: ["/buy", "Comienza ya"],
  },

  {
    linkTit: "OTM Delta Swing",
    url: "otm-delta-swing",

    imgb: "./features/otm-delta-swing.jpg",
    titb_1: "OTM Delta Swing",

    txtb0:
      "Este indicador te proporciona información valiosa acerca de los movimientos de las ondas del precio:",

    txmb1:
      "1. Información de volumen y delta: con esta información puedes evaluar si es adecuado o no tomar una posición, ya que puedes ver directamente la fuerza de cada onda.",

    txmb2:
      "2. Señales informativas: los algoritmos de OTM Delta Swing detectan anomalías, lo que significa que te permiten detectar eventos fuera de lo normal y así tener una ventaja en el mercado. El algoritmo detecta 3 tipos de anomalías y nos muestra una señal informativa al final de la onda.",

    txtb1:
      "Te recomiendo ver el siguiente video sobre las señales y los tipos de anomalías que detecta OTM Delta Swing para que puedas entenderlo mejor y obtener el máximo provecho:    ",

    lnkb1: ["https://www.youtube.com/watch?v=AWTLJAKa2VI", "OTM Delta Swing"],
  },
  {
    linkTit: "OTM Delta Micro",
    url: "otm-delta-micro",

    imgb: "./features/otm-delta-micro.jpg",
    titb_1: "OTM Delta Micro",

    txtb0:
      "Cuando hay un gran interés por parte de los compradores o vendedores en mover el precio en una dirección, se puede identificar fácilmente con este indicador. Con OTM Micro Delta podrás:",

    txmb1:
      "1. Tener un umbral de referencia: esto es clave para que filtres los movimientos importantes de los que no lo son.",

    txmb2:
      "2. Delta institucional: cuando vemos una gran 'caja verde' significa que hay una gran cantidad de compradores que quieren que el precio suba, a esto lo llamamos 'Momentum'.",

    txtb1:
      "Para utilizar este indicador de la mejor manera posible, es importante que entiendas algunos conceptos clave, pero no te preocupes, ¡son muy fáciles de entender! Además, tenemos un vídeo donde te lo explicamos todo:    ",

    lnkb1: ["https://www.youtube.com/watch?v=0LRXTXaFOko", "OTM Delta Micro"],
  },
  {
    linkTit: "OTM Delta Cumulative",
    url: "otm-delta-cumulative",

    imgb: "./features/otm-delta-cumulative.jpg",
    titb_1: "OTM Delta Cumulative",

    txtb0:
      "Este indicador es un histograma, un histograma nos muestra gráficamente las características de un conjunto de datos, en este caso resume el comportamiento del delta. El delta es una medida de la fuerza compradora o vendedora en el mercado. Algunas aplicaciones prácticas son:",

    txmb1:
      "1. Identificar transiciones de tendencia: podemos ver si una tendencia está llegando a su fin.",

    txmb2:
      "2. Identificar tendencias definidas: si queremos comprar, es importante observar una gráfica verde que va en aumento, esto indica que hay una presión constante de compradores.",

    txtb1:
      "De acuerdo al tipo de estrategia que tengas, hay algunos aspectos importantes a tener en cuenta de este indicador, por tanto, te invito a que profundices más sobre OTM Cumulative Delta en el siguiente vídeo:  ",

    lnkb1: ["https://www.youtube.com/watch?v=HJtZ3gJK1FE", "OTM Cumulative Delta"],
  },
  {
    linkTit: "OTM Delta Bar",
    url: "otm-delta-bar",

    imgb: "./features/otm-delta-bar.jpg",
    titb_1: "OTM Delta Bar",

    txtb0:
      "Si deseas conocer el valor del delta de una barra de forma detallada, OTM Delta Bar es una herramienta muy útil y versátil que te presenta múltiples opciones:",

    txmb1:
      "1. Delta acumulado de sesión: muestra el comportamiento del delta durante toda la sesión, como un gráfico de velas japonesas, pero del comportamiento del delta. Es útil para confirmar agotamientos y detectar posibles cambios en el mercado.    ",

    txmb2:
      "2. Delta por barra 1: muestra los valores positivos y negativos en la misma dirección.  ",

    txmb3:
      "3. Delta por barra 2: el delta positivo estará hacia arriba y el delta negativo hacia abajo.",

    txmb4:
      "4. BID/ASK: muestra los valores de BID (ventas agresivas) y ASK (compras agresivas) de cada vela. ",

    txmb5:
      "5. Volumen + Delta: las barras que se muestran son de volumen y el color representa el resultado del delta de la vela. La intensidad del color depende de lo grande que sea ese valor de delta en relación con su volumen.  ",

    txmb6:
      "6. Footer volumen + delta: aquí puedes ver los valores numéricos de delta, volumen, BID y ASK, entre otros. ",

    // txtb1:
    //   "La versión de pago incluye las 6 diferentes configuraciones, hay una versión gratuita que puedes descargar que incluye la configuración #1 y #3. Puedes profundizar y descargar el indicador en el siguiente botón.     ",

     lnkb1: ["https://youtu.be/Z7nISubWyaw", "OTM Delta bar"],
  },
  {
    linkTit: "OTM Volumne Profile",
    url: "otm-volume-profile",

    imgb: "./features/otm-profile.jpg",
    titb_1: "OTM Volume Profile",

    txtb0:
      "El perfil de volumen es una herramienta muy útil para entender el comportamiento de los participantes del mercado y encontrar zonas importantes donde el precio puede reaccionar. Aquí te explico algunos usos prácticos:    ",

    txmb1:
      "1. VPOC (Volume point of control): es el nivel más negociado durante la sesión, funciona como un imán para el precio y puede indicar una zona de salida en lugar de entrada.    ",

    txmb2:
      "2. Nodos de bajo volumen: son zonas donde el volumen de negociación es bajo y pueden servir como niveles de soporte o resistencia, lo que significa que el precio puede rebotar en estas zonas y ofrecer buenos puntos de entrada o salida.    ",

    txmb3:
      "3. Área de valor (Value Area): se refiere al rango de precios donde se negocia el 70% del volumen total de la sesión. Cuando el precio llega al extremo del área de valor alto (VAH) o bajo (VAL), es posible que haya una reversión de tendencia, por lo que es importante prestar atención a estas zonas.    ",

    txtb1: "Aprende más sobre OTM Volume Profile en el siguiente vídeo:    ",

    lnkb1: ["https://youtu.be/yWkcqBqUkJ4", "OTM Volume Profile"],
  },
  {
    linkTit: "OTM VWAP",
    url: "otm-wap",

    imgb: "./features/otm-vwap.jpg",
    titb_1: "OTM VWAP",

    txtb0:
      "El VWAP es un indicador muy útil en el trading y su cálculo es bastante sencillo. El VWAP significa 'Precio medio ponderado por volumen' y es como una medía móvil que se construye con el volumen de negociación del mercado. Este indicador tiene varias líneas que pueden servir de referencia para nuestras operaciones:    ",

    txmb1:
      "1. VWAP: Es el VWAP 'Central' o principal. Si el precio está por encima, lo podemos tomar como soporte y comprar cuando el precio llegue cerca de esta línea. Si el precio está por debajo, lo tomaremos como una resistencia.    ",

    txmb2:
      "2. VWAP desviación 1: El VWAP tiene unas líneas llamadas desviaciones que replican el comportamiento de la línea central a una distancia determinada (desviación estándar), las tenemos por arriba y por debajo, esta es la desviación #1 inferior.    ",

    txmb3:
      "3. VWAP desviación 2: A medida que el precio avanza con una dirección clara, cada vez se va extendiendo y posiblemente en los retrocesos no llegue al VWAP central. Aquí, las desviaciones nos pueden servir de referencia para la ubicación de nuestras operaciones.    ",

    txmb3:
      "4. VWAP desviación 3: Una vez que observamos que el precio ha llegado a la desviación #3 del VWAP, significa que el precio está muy extendido y es posible que luego vengan retrocesos muy profundos o cambios de dirección. Podemos usar esta desviación como punto de salida de nuestras operaciones.  ",

    lnkb1: ["https://youtu.be/_caBCZk4ZgI", "OTM VWAP"],
  },
  {
    linkTit: "OTM Graphic Bar Timer",
    url: "otm-bar-timer",

    imgb: "./features/otm-bar-timer.jpg",
    titb_1: "OTM Graphic Bar Timer",

    txtb0:
      "Posiblemente conoces el indicador de NinjaTrader Bar timer, que te dice cuánto tiempo queda para el cierre de una vela. Este indicador tiene el mismo principio, la diferencia es que muestra en una barra con colores el avance que lleva la construcción de la vela:    ",

    txmb1:
      "1. 25% restante: puedes poner el color que quieras, pero el color verde indica que está próximo a cerrarse la vela, esto te facilita tomar una decisión.  ",

    txmb2:
      "2. 50% restante: no ha pasado más de la mitad del tiempo para el cierre de la vela, puede ser prematuro tomar una decisión, por eso el color amarillo.    ",

    txmb3:
      "3. 75% restante: la vela hasta ahora se está formando, la información dentro de ella puede cambiar drásticamente antes del cierre, así que es mejor esperar un poco.    ",

    txtb1:
      "Este indicador te ayuda a identificar fácilmente en qué etapa se encuentra la construcción de la vela, con esto esperas la confirmación adecuada para apretar el gatillo ",

    lnkb1: ["https://youtu.be/xN0rmD1b1sM", "OTM Graphic Bar Timer"],
  },
  {
    linkTit: "Momentum",
    url: "estrategia-momentum",

    imgb: "./features/momentum.png",
    titb_1: "(Momentum) a favor de la tendencia",

    txtb0:
      "En lo posible debes ir a favor de la tendencia, aquí te digo cuáles son los requisitos de una entrada a favor de tendencia:",

    txmb1:
      "1. El VWAP a favor del movimiento: si el precio está por encima del VWAP debemos tomar posiciones de compra esperando el retroceso al VWAP y si el precio está por debajo debemos tomar posiciones de venta. Podemos usar el VWAP principal, o las desviaciones como soporte o resistencia. ",

    txmb2:
      "2. Momentum en el MicroDelta: Si estamos en un mercado alcista y observamos una gran 'caja verde' en el MicroDelta, esto indica una gran cantidad de compras agresivas. Este es un buen momento para evaluar una posición de compra en el mercado. Por otro lado, si vemos una gran 'caja roja' en el MicroDelta en un mercado bajista, esto indica ventas agresivas, lo que significa que existe un momentum bajista. ",

    txmb3:
      "3.  Respuesta débil en el retroceso: si tuvimos un gran momentum de compras (gran caja verde), lo que queremos es que el retroceso tenga mucho menos volumen que movimiento de impulso inicial.",

    txmb4:
      "4. Delta acumulado a favor: en un movimiento alcista nos confirma que tenemos una presión constante de compras y hace que nuestra posición en largo tenga mayor probabilidad.    ",

    txmb5:
      "5. Zona de bajo volumen (Low Volume Area): luego del avance del precio debes esperar el retroceso en la zona de bajo volumen que deja el perfil de volumen, esto te brinda una zona clara de entrada donde puedes apoyar tu posición. ",

    txtb1:
      "Espero que esto te haya ayudado a entender mejor los requisitos de entrada a favor de tendencia. ¡Si quieres aprender más, no dudes en hacer clic en el botón de abajo para seguir aprendiendo! ",

    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },
  {
    linkTit: "Reversals",
    url: "estrategia-reversals",

    imgb: "./features/reversal.png",
    titb_1: "(Reversals) en contra de tendencia",

    txtb0:
      "Las entradas de giros, o contra tendencia son un poco más difíciles, pero si tienes los siguientes requisitos tienes mayor probabilidad de acertar en tus operaciones:    ",

    txmb1:
      "1. Nivel objetivo de soporte o resistencia: el precio no suele cambiar de dirección sin encontrar un nivel clave. En este ejemplo, el precio se sostiene sobre el IBL (Initial Balance Low), que es el nivel mínimo que deja la sesión americana en su primera hora.",

    txmb2:
      "2. Oferta decreciente: necesitamos ver que cada vez hay menos cantidad de ventas en el MicroDelta, lo que indica que la oferta está disminuyendo.    ",

    txmb3:
      "3. Divergencia de compras: otra señal importante de que el precio podría estar a punto de cambiar de dirección es si hay cajas de divergencias. Esto significa que el precio está bajando, pero el delta no es negativo, es positivo, lo que representa una actividad compradora importante.    ",

    txmb4:
      "4. Divergencia en el delta acumulado sesional: también necesitamos confirmar que existe una divergencia entre el precio y el delta acumulado por sesión. Esto significa que el delta está creciendo y el precio sigue lateral.    ",

    txmb5:
      "5. Delta acumulado positivo (divergencia): finalmente, el histograma delta también debe ser positivo y opuesto al movimiento del precio, lo que nos confirma que hay una anomalía.",

    txtb1:
      "Si se cumplen estos requisitos, es posible que se esté produciendo un cambio de tendencia y podríamos considerar entrar en una posición de compra. Aprende más en el video que preparamos para ti.  ",

    lnkb1: ["https://otmtrading.lemonsqueezy.com/buy/bdf5bdcd-19d4-4437-9147-68cdd33a2574", "MasterClass OTM"],
  },




  //¿Listo? Revisa esto para comenzar
  {
    linkTit: "Preguntas frecuentes",
    url: "preguntas-frecuentes",

    titb_1: "Preguntas frecuentes",

    subb1:
      "1. ¿Necesito tener una licencia permanente de NinjaTrader 8 para usar OTM Trading? ",

    txmb1:
      "No, no necesitas una licencia de por vida de NinjaTrader 8 para usar OTM Trading. Puedes usar la versión demo y tendrás un buen funcionamiento. ",

    subb2:
      "2. ¿Cuál es el proceso para instalar y configurar el software en mi equipo? ",

    txmb2:
      "Una vez que compres OTM Trading, verás un sencillo formulario en el que te pediremos que ingreses tus datos personales y el código Machine ID. Con esta información, haremos un proceso de licenciamiento para tu software y te enviaremos por correo electrónico OTM Trading con todas las instrucciones y materiales educativos necesarios para que puedas usarlo de manera efectiva.    ",

    subb3:
      "3. ¿Qué tipo de Licencia obtengo después de la compra de OTM Trading?    ",

    txmb3:
      "Obtienes una Licencia de por vida, no debes pagar más dinero después de adquirir el pack de OTM Trading, es un único pago. También tienes incluidas las futuras actualizaciones de forma gratuita.     ",

    subb4:
      "4. ¿Hay un equipo de soporte técnico para resolver cualquier problema que pueda surgir?    ",

    txmb4:
      "¡Claro que sí! Si tienes algún problema después de adquirir OTM Trading, no te preocupes. ¡Estamos aquí para ayudarte! Puedes contactarnos por correo electrónico o a través de WhatsApp para resolver cualquier duda o problema que tengas. Además, ¡también puedes programar una sesión remota con nosotros para solucionar cualquier problema en tiempo real!    ",

    subb5:
      "5. ¿Cuáles son las opiniones y reseñas de otros usuarios que han utilizado OTM Trading?    ",

    txlb_5: [
      "Si quieres conocer lo que piensan otros traders sobre OTM Trading, solo tienes que hacer <link> clic aquí </link> verás cómo OTM les ha ayudado a mejorar su operativa. ",
      "https://www.otmtrading.com/features/preguntas-frecuentes",
    ],

    subb6:
      "6. ¿Qué tan precisos son los análisis y señales que brinda OTM Trading?    ",

    txmb6:
      "OTM Trading ha demostrado ser una gran herramienta para tu operativa, puedes ver su rendimiento en el año 2022 en la pestaña 'Resultados'. ¡No te pierdas la oportunidad de mejorar tus operaciones con esta herramienta!  ",

    subb7:
      "7. ¿Los indicadores sirven en cualquier temporalidad y tipo de gráfico?    ",

    txmb7:
      "Sí, puedes configurar OTM Trading en cualquier temporalidad que desees y en cualquier tipo de gráfico que prefieras. Es muy versátil.    ",

    subb8: "8. ¿En qué tipo de mercados puedo usar OTM Trading?    ",

    txmb8:
      "Con OTM Trading, puedes operar en una amplia variedad de instrumentos financieros en el mercado de futuros, como el SP500 (ES), Nasdaq (NQ), petróleo (CL), y futuros de divisas. Ten en cuenta que para algunos instrumentos, como el petróleo y las divisas, es necesario tener acceso a datos en tiempo real.    ",

    subb9: "9. ¿Debo configurar OTM Trading desde cero para usarlo?    ",

    txmb9:
      "No te preocupes, si configurar las opciones de OTM Trading te parece complicado, ¡te tenemos cubierto! En el manual de instalación que recibirás junto con OTM Trading, incluimos una plantilla gratuita que te permitirá crear gráficos con configuraciones predefinidas en cuestión de un solo clic. ¡Es súper fácil!    ",

    subb10:
      "10. ¿Existe una comunidad de usuarios de OTM Trading con la que pueda interactuar y compartir experiencias?  ",

    txlb10: [
      "Después de adquirir OTM Trading, ¡tienes acceso a una comunidad de apoyo y recursos adicionales! Puedes unirte a nuestro canal privado de Telegram y servidor de Discord para recibir apoyo y compartir tus experiencias con otros usuarios. <link>¡Haz clic aquí para unirte ahora mismo!</link>  ",
      "https://t.me/comunidad3c",
    ],

    subb11:
      "11. ¿OTM Trading requiere de “tick replay” para su funcionamiento?    ",

    txmb11:
      "OTM Trading no usa tick replay en su versión 2.5, ¡así que puedes usarlo sin preocuparte por eso!, no tendrás un software que ralentice tu computadora.  ",

    subb12:
      "12. ¿OTM Trading me informa dónde entrar y dónde salir en mis operaciones?    ",

    txmb12:
      "OTM Trading te brinda información con los diferentes indicadores, pero al final la decisión de cómo operar es tuya. No es un sistema de trading automático que haga operaciones por ti, sino que te da la información para que tú puedas tomar tus propias decisiones informadas. ",

    subb13: "13. ¿Cuál es la mejor manera de usar OTM Trading?   ",

    txlb13: [
      " Si quieres obtener los mejores resultados con OTM Trading, es importante que tengas confirmación en todos los indicadores en la dirección que deseas operar. Si necesitas ayuda con OTM Trading, ¡no te preocupes! Tenemos vídeos educativos sobre las diferentes estrategias disponibles. Solo tienes que hacer <link> clic aquí </link>   para acceder a ellos y aprender a usar OTM Trading de la mejor manera.",
      "https://www.otmtrading.com/features/estrategia-momentum",
    ],

    subb14:
      "14. ¿Cuáles son los requerimientos mínimos de mi computadora para utilizar OTM Trading de manera óptima?    ",

    txmb14:
      "No te preocupes, los requisitos para usar OTM Trading son sencillos. Son los mismos que piden para usar la plataforma NinjaTrader 8, y son fácilmente cumplibles en la mayoría de los equipos:  ",

    tmnb1:
      "- Windows 8.1, Windows 10, Windows 11, Windows Server 2012 o posterior algo",
    tmnb2: "- 1 Gigahercio (GHz) o más rápido. Procesador de 32 bit o 64 bit ",
    tmnb3: "- 2GB RAM",
    tmnb4:
      "- Sistema Microsoft. NET 4.8 (pre-instalado en la mayoría de PC's y también puede ser descargado en: Microsoft .NET Framework)    ",
    tmnb5: "- Resolución de pantalla mínima 1024 x 768",
    tmnb6:
      "- Compatibilidad con tarjeta de gráficos DirectX 10 es altamente recomendable  ",

    subb15: "15. ¿Se puede realizar Replay Market con OTM Trading?    ",

    txmb15:
      "¡Sí! Puedes repetir la experiencia de tener el mercado en vivo con OTM Trading utilizando la función Replay Market de NinjaTrader 8.    ",

    subb16:
      "16. ¿Existe algún costo adicional o suscripciones requeridas después de la compra inicial?  ",

    txmb16:
      "No te preocupes, después de adquirir OTM Trading, no existen costos adicionales ni suscripciones requeridas para su uso. ¡Estarás listo para comenzar a mejorar tus operaciones!    ",

    subb17:
      "17. ¿Cómo se realiza la actualización de OTM Trading y cuánto cuesta?    ",

    txmb17:
      "Después de comprar OTM Trading, no te preocupes por costos adicionales o suscripciones. Si hay una nueva versión disponible, te lo haremos saber por correo electrónico con las instrucciones para actualizar, ¡y no te costará nada extra!    ",

    subb18:
      "18. ¿El software es intuitivo y fácil de usar para traders de todos los niveles de experiencia?    ",

    txmb18:
      "No te preocupes, te enseñamos cómo instalar y configurar OTM Trading con nuestro manual de instrucciones fácil de seguir. Incluso si tienes conocimientos básicos en la plataforma NinjaTrader 8, lo podrás hacer sin problema. Además, te brindamos educación para que puedas sacar el máximo provecho a los indicadores.    ",

    subb19:
      "19. ¿OTM Trading permite automatizar mis operaciones de trading?    ",

    txmb19:
      "Lo siento, por ahora no es posible crear estrategias automatizadas con los indicadores de OTM Trading, pero nuestro equipo de expertos está trabajando constantemente en mejorar y expandir las funciones del software.    ",

    subb20:
      "20. ¿Hay una versión demo disponible para probar OTM Trading antes de comprarlo?    ",

    txmb20:
      "Lo sentimos, en este momento no tenemos una versión de prueba disponible, pero puedes programar una cita con uno de nuestros asesores haciendo clic aquí. ¡Será un placer ayudarte a solucionar tus dudas y mostrarte todo lo que OTM Trading puede ofrecerte!    ",
  },
  {
    linkTit: "Opiniones de usuarios",
    url: "opiniones",

    titb_1: "Opiniones de usuarios",

    subb1: "Federico Verdejo ",
    ivib1: "./rev_federico_verd.mp4",
    txmb1:
      "“Entender que fuerza de volumen y de delta tiene cada swing, cada movimiento, ha afinado mucho dónde entrar y cuándo salir también”.",

    subb2: "Gustavo Loiz ",
    ivib2: "./rev_gustavo_loiz.mp4",
    txmb2:
      "“Estas herramientas que me permiten ver el mercado con rayos X, aumenté el porcentaje de efectividad de mis operaciones, mi operativa antes de OTM era un desastre y subjetiva, pero con las herramientas de OTM mi operativa cambió muchísimo”.",

    subb3: "William Franco",
    ivib3: "./rev_william_franc.mp4",
    txmb3:
      "“Desde que adquirí los indicadores de OTM mi operativa en el Trading cambió, mi operativa se volvió más sólida y robusta, no se necesita muy experimentado para poder usarlos”  ",

    // lnkb1:["https://www.quantower.com/blog","Testimonios"]
  },
  {
    linkTit: "¿Hago el pago y luego?",
    url: "pagos",

    titb_1: "¿Hago el pago y luego?",

    iinb: "./features/compra.jpg",

    txtb1:
      "Una vez que hayas comprado OTM Trading, recibirás un formulario en el que deberás ingresar tus datos personales, como tu nombre, correo electrónico y código Machine ID. No te preocupes si no sabes cómo obtener el código Machine ID, ya que el formulario tiene una imagen tutorial para guiarte. Una vez que hayas completado el formulario, envíalo y ¡listo! Nosotros procesaremos tu licencia lo antes posible y te enviaremos un correo electrónico con todas las instrucciones necesarias para descargar, instalar y comenzar a utilizar OTM Trading. Además, también te proporcionaremos una lista de vídeos educativos recomendados para que puedas aprovechar al máximo la herramienta.",

    txtb2:
      "Si necesitas ayuda con la financiación, puedes hacer clic aquí y contactarte con uno de nuestros asesores a través de WhatsApp para obtener información sobre los diferentes métodos de pago y opciones de financiación disponibles para comprar OTM Trading.",

    txlb_3: [
      "También puedes enviarnos tus dudas o preguntas haciendo <link> clic aquí </link>. Estaremos encantados de ayudarte en lo que necesites. ",
      "http://bit.ly/42VBmoV",
    ],
  },
];
